/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */
import {
  INavStyleProps,
  INavStyles,
  IStyleFunctionOrObject,
} from "@fluentui/react";

export const firstNavStyles: IStyleFunctionOrObject<
  INavStyleProps,
  INavStyles
> = (props: INavStyleProps) => ({
  root: {
    display: "flex",
    width: "70%",
    overflowY: "unset",
    float: "left",
    minHeight: 70,
    fontFamily:
      "'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI', '-apple-system', 'BlinkMacSystemFont', 'Roboto', 'Helvetica Neue', 'sans-serif'",
  },
  group: {
    minWidth: 0,
    selectors: {
      "@media screen and (min-width: 1120px)": {
        transition: "background-color ease-out .5s",
        transitionProperty: "background-color",
        transitionDuration: "0.5s",
        transitionTimingFunction: "ease-out",
        transitionDelay: "0s",
      },
      ":hover": {
        background: "#464646",
        color: "#FFFFFF",
      },
    },
  },
  chevronButton: {
    paddingLeft: 6,
    paddingRight: 28,
    borderBottom: "none",
    fontSize: 14,
    padding: "unset",
    margin: "unset",
    height: "unset",
    lineHeight: "unset",
    fontFamily: "inherit",
  },
  chevronIcon: {
    right: 8,
    left: "unset",
    height: "unset",
    lineHeight: "unset",
    paddingTop: 4,
    transform: props.isExpanded ? "rotate(-180deg)" : "unset",
    pointerEvents: "none",
  },
  groupContent: {
    display: "block",
    marginTop: 28,
  },
  navItem: {
    background: "#2F2F2F",
  },
  compositeLink: {
    selectors: {
      ":hover": {
        background: "#464646",
      },
    },
  },
  link: {
    padding: "16px 20px 16px 20px",
    height: "unset",
    lineHeight: "unset",
    backgroundColor: "#464646",
    selectors: {
      ":hover": {
        backgroundColor: "#464646 !important",
      },
    },
  },
  linkText: {
    height: "unset",
    lineHeight: "unset",
    fontSize: 14,
    margin: "unset",
    color: "#FFFFFF",
    fontFamily:
      "'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI', '-apple-system', 'BlinkMacSystemFont', 'Roboto', 'Helvetica Neue', 'sans-serif'",
  },
});

export const secondNavStyles: IStyleFunctionOrObject<
  INavStyleProps,
  INavStyles
> = (props: INavStyleProps) => ({
  root: {
    display: "flex",
    width: "30%",
    justifyContent: "flex-end",
    overflowY: "unset",
    minHeight: 70,
    fontFamily:
      "'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI', '-apple-system', 'BlinkMacSystemFont', 'Roboto', 'Helvetica Neue', 'sans-serif'",
  },
  group: {
    padding: "24px 0px 24px 36px",
    transition: "background-color ease-out .5s",
    transitionProperty: "background-color",
    transitionDuration: "0.5s",
    transitionTimingFunction: "ease-out",
    transitionDelay: "0s",
    selectors: {
      ":hover": {
        background: "#464646",
        color: "#FFFFFF",
      },
    },
  },
  chevronButton: {
    paddingLeft: 6,
    paddingRight: 28,
    borderBottom: "none",
    fontSize: 14,
    padding: "unset",
    margin: "unset",
    height: "unset",
    lineHeight: "unset",
    fontFamily: "inherit",
  },
  chevronIcon: {
    right: 8,
    left: "unset",
    height: "unset",
    lineHeight: "unset",
    paddingTop: 4,
    transform: props.isExpanded ? "rotate(-180deg)" : "unset",
    pointerEvents: "none",
  },
  groupContent: {
    display: "block",
    marginTop: 27,
    minWidth: 100,
    width: 230,
  },
  navItems: {
    border: "1px solid #f6f6f6",
  },
  navItem: {
    background: "#2F2F2F",
  },
  compositeLink: {
    selectors: {
      ":hover": {
        background: "#f6f6f6",
      },
    },
  },
  link: {
    padding: "16px 20px 16px 20px",
    height: "unset",
    lineHeight: "unset",
    backgroundColor: "#FFFFFF",
    borderRadius: "unset",
    selectors: {
      ":hover": {
        backgroundColor: "#f6f6f6 !important",
      },
    },
  },
  linkText: {
    height: "unset",
    lineHeight: "unset",
    fontSize: 14,
    margin: "unset",
    color: "#2F2F2F",
    fontFamily:
      "'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI', '-apple-system', 'BlinkMacSystemFont', 'Roboto', 'Helvetica Neue', 'sans-serif'",
  },
});
